export const GET_ITEM = 'GET_ITEM';
export const GET_ITEM_SUCCESS = 'GET_ITEM_SUCCESS';
export const GET_ITEM_ERROR = 'GET_ITEM_ERROR';

export const RESET_ITEM = 'RESET_ITEM';

export const SET_NEXT_ITEM_DATA = 'SET_NEXT_ITEM_DATA';
export const RESET_NEXT_ITEM_DATA = 'RESET_NEXT_ITEM_DATA';

export const DELETE_ITEMS = 'DELETE_ITEMS';
export const DELETE_ITEMS_SUCCESS = 'DELETE_ITEMS_SUCCESS';
export const DELETE_ITEMS_ERROR = 'DELETE_ITEMS_ERROR';

export const ITEM_BATCH_UPDATE = 'ITEM_BATCH_UPDATE';
export const ITEM_BATCH_UPDATE_SUCCESS = 'ITEM_BATCH_UPDATE_SUCCESS';
export const ITEM_BATCH_UPDATE_ERROR = 'ITEM_BATCH_UPDATE_ERROR';

export const ITEM_UPDATE = 'ITEM_UPDATE';
export const ITEM_UPDATE_SUCCESS = 'ITEM_UPDATE_SUCCESS';
export const ITEM_UPDATE_ERROR = 'ITEM_UPDATE_ERROR';

export const ITEM_CREATE = 'ITEM_CREATE';
export const ITEM_CREATE_SUCCESS = 'ITEM_CREATE_SUCCESS';
export const ITEM_CREATE_ERROR = 'ITEM_CREATE_ERROR';

export const ITEM_LIKE = 'ITEM_LIKE';
export const ITEM_LIKE_SUCCESS = 'ITEM_LIKE_SUCCESS';
export const ITEM_LIKE_ERROR = 'ITEM_LIKE_ERROR';

export const SET_UPDATED_ITEMS = 'SET_UPDATED_ITEMS';
export const RESET_UPDATED_ITEMS = 'RESET_UPDATED_ITEMS';
